<template>
    <div class="department">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" :icon="icon" @createForm="openDialog"></myBreadCrumb> -->
        <create-dialog ref="createDialog" @needFetch="fetchData"></create-dialog>
        <v-card flat class="rounded-xl">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Danh sách phòng ban
                <v-spacer></v-spacer>

                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
                </div>

                <v-divider vertical class="mx-4"></v-divider>

                <!-- <import-upload :url="IMPORT_URL"></import-upload> -->
                <export-prompt url="departments" fileName="PHONG_BAN" v-model="exportPrompt"></export-prompt>
                <v-btn @click="exportPrompt=true" dark color="blue darken-3" class="rounded-pill elevation-3 mx-2 font-weight-bold px-4"> <v-icon left>mdi-export</v-icon> XUẤT EXCEL </v-btn>

                <!-- <data-filter v-model="params" :filter="filter" @fetchData="fetchData"></data-filter> -->

                <v-btn @click="openDialog" dark color="teal darken-4" class="rounded-pill elevation-3 ml-4 font-weight-bold px-6"> <v-icon left>mdi-plus</v-icon> TẠO PHÒNG BAN </v-btn>
            </v-card-title>
            
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap mx-n2 px-4">
                    <v-select label="Khối" :items="departmentTypes" item-text="name" item-value="value" dense outlined hide-details v-model="filterDeptType" persistent-placeholder placeholder="Chọn Khối" clearable
                    class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="min-width: 150px; background-color: white;" ></v-select>

                    <v-text-field label="Mã phòng ban" dense outlined hide-details v-model="filterCode" persistent-placeholder placeholder="TS00.." clearable
                    class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="min-width: 150px; background-color: white;" ></v-text-field>

                    <v-text-field label="Tên phòng ban" dense outlined hide-details v-model="filterName" persistent-placeholder placeholder="Tên phòng ban" clearable
                    class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="min-width: 250px; background-color: white;" ></v-text-field>

                    <v-autocomplete label="Vùng/Thành phố" item-text="name" item-value="code" :items="cities" clearable dense outlined hide-details v-model="filterCityCode" persistent-placeholder placeholder="Chọn Tỉnh/Thành phố"
                    class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="min-width: 150px; background-color: white;" ></v-autocomplete>

                    <v-text-field label="Asm" dense outlined hide-details v-model="filterAsm" persistent-placeholder placeholder="Nhập Asm..." clearable
                    class="mx-2 my-2 flex-grow-1 flex-shrink-0" style="min-width: 150px; background-color: white;" ></v-text-field>
                </div>
            </v-sheet>
            
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5" style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phòng ban: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>
            </v-sheet>
            
            <v-data-table height="600px"
            :headers="headers"
            :items="departments"
            :loading="isLoading"
            loading-text="Đang tải dữ liệu..."
            >
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn x-small depressed rounded class="mx-1 my-1 blue-grey--text text--darken-3 font-weight-bold" color="blue-grey lighten-4" @click="editItem(item)" >
                        <v-icon left small>mdi-pencil</v-icon> Sửa
                    </v-btn>
                    
                    <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold" color="grey lighten-4" @click="deleteItem(item)">
                        <v-icon left small>mdi-delete</v-icon> Xóa
                    </v-btn>
                </template>
                <template v-slot:[`item.deptType`]="{ item }">
                    <div class="subtitle-2 font-weight-bold">{{ item.deptType }}</div>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{ item.name }}</div>
                </template>
                <template v-slot:[`item.city`]="{ item }">
                    <v-chip v-if="item.city" small color="teal lighten-5" text-color="teal darken-4" class="font-weight-medium">
                        <v-icon left small>mdi-map-marker-outline</v-icon>
                        {{ item.city }}
                    </v-chip>
                </template>
                <template v-slot:[`item.asm`]="{ item }">
                    <div v-if="item.asm"><v-icon small left class="grey--text">mdi-account</v-icon>{{ item.asm }}</div>
                </template>
            </v-data-table>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                    <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
// import myBreadCrumb from '@/components/BreadCrumb';
import DataFilter from '@/components/DataFilter';
import http from '@/components/services/http-common';
import DepartmentCreateDialog from './Create';
import ImportUpload from '@/components/ImportUpload';

export default {
    name: 'Department',
    components: {
        'data-filter': DataFilter,
        'create-dialog': DepartmentCreateDialog,
        'import-upload': ImportUpload,
    },
    data () {
        return {
            ROOT_URL: "departments",
            DEPARMENTTYPE_URL: "DepartmentTypes",
            IMPORT_URL: "departments/import",
            CITY_URL: "departments/fetch-city",

            //filter
            params: {
                sortBy: [],
                sortDesc: [],
                page: "",
                itemsPerPage: "",
                searchs: [],
                searchAttrs: [],
            },

            filter: {
                menu: false,
                search: "",
                searchAttr: "name",
                searchAttrs: undefined,
                FilterAttrs: [
                    {text: "Khối", items: [] },
                    {text: "Thành phố", items: [] },

                ],
                FilterOn:["DepartmentTypeCode", "City"],
                
                from: undefined,
                to: undefined,
                fromOns: [
                ],
                fromOn: "",
            },

            // VIEW DATA
            filterOpen: 1,
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },

            exportPrompt: false,
            //filter
            filterDeptType:null,
            cities:[],
            filterCode:null,
            filterName:null,
            filterLaunchDate:null,
            filterCityCode:null,
            filterAsm:null,
            departmentTypes : [],
            
            //datatable config
            totalItem: 0,
            departments: [],
            search:"",
            options: {},
            isLoading: true,
            dialog: false,
            dialogDelete: false,
            targetItem: undefined,
        }
    },
    
    computed: {
        headers() {
            return [
                { text: 'Thao tác', value: 'actions', width: '15rem' },
                { text: 'Khối', align: 'start', value: 'deptType', width: '10rem', filter: value => {
                    if (!this.filterDeptType) return true
                    return (value || "").toUpperCase().indexOf(this.filterDeptType.toUpperCase()) > -1
                    }
                },
                { text: 'Mã phòng', align: 'start', sortable: true, value: 'code', width: '7rem', filter: value => {
                    if (!this.filterCode) return true
                    return (value || "").indexOf(this.filterCode) > -1
                    } },
                { text: 'Tên phòng ban', align: 'start', value: 'name', width: '18rem', filter: value => {
                    if (!this.filterName) return true
                    return (value || "").toUpperCase().indexOf(this.filterName.toUpperCase()) > -1
                    } 
                },
                { text: 'Vùng/Thành phố', value: 'city', width: '10rem' },
                { text: '', value: 'cityCode', class: "d-none", cellClass:"d-none", filter: value => {
                    if (!this.filterCityCode) return true
                    return value == this.filterCityCode;
                    }
                },
                { text: 'Asm', value: 'asm', width: '8rem', filter: value => {
                    if (!this.filterAsm) return true
                    return (value || "").toUpperCase().indexOf(this.filterAsm.toUpperCase()) > -1
                    }
                },
                { text: 'Ngày khai trương', align: 'start', value: 'launchDate', width: '10rem', filter: value => {
                    return true;
                    } 
                },
            ];
        },
        totalCount() {
            // Because filter happens in data table, but we can return total elements initially.
            // If they want filtered count, they'd have to use datatable @current-items. 
            // We just return total items loaded from api here for simplicity.
            return this.departments.length;
        }
    },
    methods:{
        openDialog(){
            this.$refs.createDialog.dialog = true;
        },
        fetchData () {
            return http.get(this.ROOT_URL).then(res => {
                this.departments = res.data;
            }).finally(() => {
                this.isLoading = false;
            });
        },
        
        fetchDepartmentType() {
            return http(this.DEPARMENTTYPE_URL, {
                params: {dropDown: 1}
            })
            .then(res => {
                // this.filter.FilterAttrs[0]={text: "Khối", items: res.data };
                this.departmentTypes = res.data;
            })
            .catch(err => console.log(err))
        },
        
        // fetchCity() {
        //     return http(this.CITY_URL)
        //     .then(res => {
        //         this.filter.FilterAttrs[1]={text: "Thành phố", items: res.data };
        //     })
        //     .catch(err => console.log(err))
        // },
        fetchCity() {
            return http(this.CITY_URL)
            .then(res => {
                this.cities=res.data;
            })
            .catch(err => console.log(err))
        },

        editItem(item) {
            this.$refs.createDialog.isUpdate = true;
            this.$refs.createDialog.item = item;
            this.$refs.createDialog.fetchUpdate(item.code);
            this.$refs.createDialog.dialog = true;
        },
        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            return http.delete(this.ROOT_URL + "/"+this.targetItem.code).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                console.log(err)
            })
        },

        syncElearning(item) {
            try{
                return http.get(this.ROOT_URL + "/elearning/"+ item.code).then(() => {
                    alert("Đồng bộ elearning thành công")
                })
            }catch(e) {
                alert("Có lỗi xảy ra " + e)
            }
        }
    },
    watch: {
      options: {
        handler (val) {
            this.fetchData();
        },
        deep: true,
      },
      search:{
          handler() {
            this.options.page = 1;
          }
      }
    },
    created() {
        this.fetchDepartmentType();
        this.fetchCity();
    },
    mounted () {
        this.fetchData();
    }
}
</script>

<style lang="stylus" scoped>

</style>